import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/i18n/LanguageContext";
import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import Garage from "@/pages/Garage";
import VehicleDetail from "@/pages/VehicleDetail";
import Request from "@/pages/Request";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminVehicles from "@/pages/admin/AdminVehicles";
import AdminInquiries from "@/pages/admin/AdminInquiries";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/garage" element={<Garage />} />
              <Route path="/garage/:id" element={<VehicleDetail />} />
              <Route path="/request" element={<Request />} />
              <Route path="/contact" element={<Contact />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminOverview />} />
              <Route path="vehicles" element={<AdminVehicles />} />
              <Route path="inquiries" element={<AdminInquiries />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#0F0F0F",
              color: "#fff",
              border: "1px solid rgba(198, 161, 91, 0.3)",
              borderRadius: 0,
            },
          }}
        />
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
